import type { ReactNode } from 'react'

interface PanelProps {
  title: string
  /** Right-aligned metadata in the header. Keep it to a few characters. */
  note?: ReactNode
  actions?: ReactNode
  scroll?: boolean
  flush?: boolean
  grow?: boolean
  className?: string
  children: ReactNode
}

/** The only frame in the product. Every box on screen is one of these. */
export function Panel({
  title,
  note,
  actions,
  scroll = false,
  flush = false,
  grow = false,
  className = '',
  children,
}: PanelProps) {
  return (
    <section className={`panel ${grow ? 'panel--grow' : ''} ${className}`}>
      <header className="panel__head">
        <span className="panel__tick" aria-hidden="true" />
        <h2 className="panel__title">{title}</h2>
        {actions ? <div className="panel__actions">{actions}</div> : null}
        {note ? <div className="panel__note">{note}</div> : null}
      </header>
      <div className={`panel__body ${scroll ? 'u-scroll' : ''} ${flush ? 'panel__body--flush' : ''}`}>
        {children}
      </div>
    </section>
  )
}
